import { render, staticRenderFns } from "./TCardAuth.vue?vue&type=template&id=5db2b954&scoped=true"
import script from "./TCardAuth.vue?vue&type=script&lang=js"
export * from "./TCardAuth.vue?vue&type=script&lang=js"
import style0 from "./TCardAuth.vue?vue&type=style&index=0&id=5db2b954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db2b954",
  null
  
)

export default component.exports